import React from "react"

export default React.createContext({ user: null, setUser: () => null, setLoginStatus: () => null })
